export const mockUsersData = [
    {
        username: "Jason",
        _id: "04849ndjdjd",
        createdAt: "2022-07-21T03:18:52.985Z"
    },
    {
        username: "Mark",
        _id: "048sdsdsdjdjd",
        createdAt: "2022-01-21T03:18:52.985Z"
    },
    {
        username: "Amelia",
        _id: "04849ndj0987",
        createdAt: "2021-12-29T03:18:52.985Z"
    },
    {
        username: "Sophia",
        _id: "04ptrendjdjd",
        createdAt: "2023-01-01T03:18:52.985Z"
    },
    {
        username: "Daniel",
        _id: "0trewtrendjdjd",
        createdAt: "2023-04-14T03:18:52.985Z"
    },
]